import React from "react";
import { Row, Col } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import SelectComponent from "../../../../_Components/ReactSelectComponent";

function MobileViewOfrequestOfCancle({ item, showPrice, errors, reasonList, inputOnChange }) {
  const { control } = useFormContext()
  return (
    <>
      <Col className="px-0">
        <Col className="d-flex justify-content-end my-2">  {item.personFullName}</Col>
        <Col className="d-flex justify-content-end my-2">   {item.cancelStatusS}</Col>
        <Col className="d-flex justify-content-end my-2">   {`${showPrice.format(item.price)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2">   {`${showPrice.format(item.paymentAmount)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2">   {`${showPrice.format(item.payToWarantyAmount)}تومان`}</Col>
        <Col className="d-flex justify-content-end my-2">   {`${showPrice.format(item.receiveOfWarantyAmount)}تومان`}</Col>

      </Col>
      <Row className="mx-auto  w-100">
        <Col>
          <Controller
            name={"cancelType" + item.id}
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <SelectComponent
                className={
                  errors["cancelType" + item.id]
                    ? "border w-250px border-danger my-3"
                    : "my-3"
                }
                noLabel
                placeholder="انتخاب وضعیت"
                options={reasonList?.map(item => ({ value: item.id, label: item.title }))}
                field={field}
                onChange={(newValue) => {
                  inputOnChange(newValue?.value, "cancelType", item, true)
                  field.onChange(newValue)
                }
                }
              />
            )}
          />
        </Col>

      </Row>
    </>);
}

export default MobileViewOfrequestOfCancle
